import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/payroll/employees_/$employeeId")({
  component: () => <Outlet />,
});
